import axios, { AxiosError } from 'axios';
import history from 'utils/history';

const apiKeyCloak = axios.create({
  baseURL: process.env.REACT_APP_BASEURL_BACKEND_KEYCLOAK,
});

apiKeyCloak.interceptors.response.use(
  (response) => {
    return response;
  },
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      if (error.response?.data?.error === 'Unauthorized') {
        localStorage.removeItem('token');
        apiKeyCloak.defaults.headers.Authorization = undefined;
        history.push('/');
      }
    }
    return Promise.reject(error);
  }
);
export default apiKeyCloak;
